import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { toRefs, ref } from "@vue/reactivity";
import { useConfirm } from "primevue/useconfirm";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  props: {
    postId: null
  },
  emits: ["delete-click"],
  setup(__props: any, { emit }) {

const props = __props as {
  postId: string
}





const { postId } = toRefs(props);

const router = useRouter();
const confirm = useConfirm();

const menu = ref();
const items = ref([
  {
    label: "Edit",
    icon: "pi pi-pencil",
    command: () => {
      router.push(`/post/${postId.value}/edit`);
    },
  },
  {
    label: "Delete",
    icon: "pi pi-trash",
    command: () => {
      confirm.require({
        message: "Are you sure you want to delete this post?",
        acceptLabel: "Delete",
        rejectLabel: "Cancel",
        header: "Delete Confirmation",
        icon: "pi pi-exclamation-triangle",
        acceptClass: "p-button-danger",
        accept: () => emit("delete-click")
      });
    },
  },
]);

const openMenu = (event: Event) => {
  menu.value.toggle(event);
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Menu = _resolveComponent("Menu")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Button, {
      onClick: _withModifiers(openMenu, ["stop"]),
      class: "p-button-secondary p-button-text p-button-sm p-button-rounded",
      icon: "pi pi-ellipsis-h",
      "aria-haspopup": "true",
      "aria-controls": "overlay_menu",
      "data-test": "ellipsis"
    }, null, 8, ["onClick"]),
    _createVNode(_component_Menu, {
      id: "overlay_menu",
      ref_key: "menu",
      ref: menu,
      popup: true,
      model: items.value
    }, null, 8, ["model"])
  ]))
}
}

})